// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_price__container__IzdQ-","priceDetailsHiddenBlock":"quote_price__priceDetailsHiddenBlock__dhTt9"};